import React from 'react';
import { Form } from 'antd';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};

// ant wrapped redux form examples: https://codesandbox.io/s/JZYL70WpK
const makeField = Component => ({ input, meta, children, hasFeedback, label, ...rest }) => {
  const hasError = meta.touched && meta.invalid;
  return (
    <Form.Item
      {...formItemLayout}
      label={label}
      validateStatus={hasError ? 'error' : 'success'}
      hasFeedback={hasFeedback}
      help={hasError && meta.error}
      >
        <Component {...input} {...rest} children={children} />
      </Form.Item>
    );
  };

export default makeField



// WEBPACK FOOTER //
// ./src/account/profile/makeField.js